import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-policy-modal',
  templateUrl: './policy-modal.component.html',
  styleUrls: ['./policy-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PolicyModalComponent {
  @Input() active;
  @Output() closed: EventEmitter<boolean> = new EventEmitter();
  @Input() information;

  constructor() {}

  closeModal() {
    this.active = false;
    this.closed.emit(false);
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/footer/policy-modal/policy-modal.component.ts